{
  "loading": "Loading comments...",
  "title": "Comments ({{total}})",
  "placeholder": "Leave a comment...",
  "submit": "Comment",
  "empty": "No comments yet. Be the first!",
  "badges": {
    "admin": "Admin",
    "instructor": "Instructor"
  },
  "edited": "(edited)",
  "actions": {
    "save": "Save",
    "cancel": "Cancel",
    "reply": "Reply",
    "edit": "Edit",
    "pin": "Pin",
    "unpin": "Unpin",
    "delete": "Delete"
  },
  "replyPlaceholder": "Write a reply...",
  "viewReplies_one": "View {{count}} reply",
  "viewReplies_zero": "View {{count}} replies",
  "viewReplies_other": "View {{count}} replies",
  "toast": {
    "created": "Comment posted successfully!",
    "createError": "Error posting comment",
    "updated": "Comment updated!",
    "updateError": "Error updating comment",
    "deleted": "Comment deleted!",
    "deleteError": "Error deleting comment",
    "pinToggled": "Comment pinned/unpinned!",
    "pinError": "Error pinning comment"
  }
}
